import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

/**
 * Cancel / Save at the bottom of a profile page's details panel. Save stores
 * the open tile only (useProfileTileSave), so it does not submit the form.
 */
export default function ProfileFormFooter({ isPending, onCancel, onSave }) {
  const { t } = useTranslation('forms');

  return (
    <div className="form-footer form-footer--sticky !grid-cols-1">
      <div
        data-tour="profile-save"
        className="flex w-full items-center justify-end gap-2"
      >
        <Button
          type="default"
          disabled={isPending}
          className="btn-default btn-default--hover"
          onClick={onCancel}
        >
          {t('cancel')}
        </Button>

        <Button
          type="primary"
          onClick={onSave}
          loading={isPending}
          disabled={isPending}
          className="btn-primary"
        >
          {t('save')}
        </Button>
      </div>
    </div>
  );
}
